import { IBusStop } from "@/domain/entities/busStop";
import { IBusLocation } from "@/domain/entities/lineInfo";
import { BUS_LOCATION_CACHED_TIME_MILLIS, BusStopEventCode } from "@/types";
import useConvertCurrentTimeToMinutes from "@/use/useConvertCurrentTimeToMinutes";
import useConvertTimeStrToMinutes from "@/use/useConvertTimeStrToMinutes";
import dayjs, { Dayjs } from "dayjs";

/** 현재 시각이 종점 도착시각보다 몇 분 지났는지 구하는 함수 ('분' 단위) */
export const getMinutesSinceLastStopArrival = (lastBusStop: IBusStop) => {
  const timeDiffMinFromLastArrivalTime =
    useConvertTimeStrToMinutes(lastBusStop.arrivalTime) -
    useConvertCurrentTimeToMinutes();

  return timeDiffMinFromLastArrivalTime;
};

/** 현재 시각이 기점 출발 시각보다 몇분 빠른지 구하는 함수 ('분' 단위) */
export const getMinutesUntilDepartureTime = (firstBusStop: IBusStop) => {
  return (
    useConvertTimeStrToMinutes(firstBusStop.arrivalTime) -
    useConvertCurrentTimeToMinutes()
  );
};

/** 실시간 버스 위치 API 호출 시각을 관리하는 함수 */
export const createBusLocationUpdatedTimeManager = (
  cachedTimeIllis = BUS_LOCATION_CACHED_TIME_MILLIS
) => {
  let busLocationsUpdatedAt: Dayjs | undefined;

  const updateBusLocationUpdatedAt = (time?: Dayjs) => {
    busLocationsUpdatedAt = time;
    return busLocationsUpdatedAt;
  };

  const isLocationCacheExpired = () => {
    return (
      !busLocationsUpdatedAt ||
      dayjs().diff(busLocationsUpdatedAt, "millisecond") > cachedTimeIllis
    );
  };

  return {
    busLocationsUpdatedAt,
    updateBusLocationUpdatedAt,
    isLocationCacheExpired,
  };
};

/** BusStopEvent가 존재하는지 확인 하는 함수 */
export const hasAnyBusStopEvent = (busLocations: IBusLocation[]) => {
  return busLocations.some((location) =>
    location.busStopEvents.some(
      (event) => event.busStopEventCode !== BusStopEventCode.None
    )
  );
};
